import { getShopWidgetConfigs } from '../../components/Sections/ShopSection/shopWidgetConfigs';
import {
  getCommonSectionInitActions,
  getCustomInitActionsForWidgets,
  getRawSectionModules,
  getModuleByType,
} from './common';
import { setTotalPages, setCurrentPage } from '../../actions/pageInfo';

export function getShopSectionInitActions(responseData, requestParams) {
  const initActions = getCommonSectionInitActions(
    responseData,
    requestParams,
    'shop'
  ).filter(action => action);
  return [
    ...initActions,
    ...getShopCurrentPageInitActions(responseData, requestParams),
    ...getShopTotalPageInitActions(responseData, requestParams),
  ];
}

/** set the shop's currentPage from the request params */
function getShopCurrentPageInitActions(responseData, requestParams) {
  const currentPage = requestParams.page ? parseInt(requestParams.page, 10) : 1;
  return [setCurrentPage(currentPage)];
}

/** set the totalPages of the current stream of shop products (if any) */
function getShopTotalPageInitActions(responseData, requestParams) {
  // note that if we try this in the individual shop product module
  // inits in modules.ts, they will overwrite each other since the
  // `totalPages` are shared between them
  const { shop_section } = requestParams;
  if (!shop_section) {
    return [];
  }

  // we're only interested in the totalPages, so can use raw here
  const modules = getRawSectionModules(responseData);
  const shopSectionModule = getModuleByType(modules, shop_section);
  if (!shopSectionModule) {
    return [];
  }

  const totalPages = shopSectionModule.module_data?.totalPages;
  return totalPages === 0 || totalPages ? [setTotalPages(totalPages)] : [];
}

// new grusers
export const getCustomInitActionsForShopWidgets = (
  responseData,
  requestParams
) => [
  ...getCustomInitActionsForWidgets(
    responseData,
    requestParams,
    getShopWidgetConfigs({ t: () => null, dispatch: () => null })
  ),
];
